<template>
  <aside v-if="condition" id="hint">
    <p><slot></slot></p>
  </aside>
</template>
<script>
export default {
  name: 'Hint',
  props: {
    condition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/css/variables.scss";
#hint {
  padding: 0 15px;
  margin: 0 0 10px 0;
  p {
    margin: 0;
    color: #5373FF;
    background-color: #D6DCF5;
    font-family: $secondaryFont;
    font-weight: $secondaryFontNormal;
    font-size: 16px;
    margin: 15px 0 15px 0;
    padding: 12px 16px;
    border-radius: 8px;
  }
}
@media(min-width:767px) {
  #hint {
    padding: 0 40px;
    p {
      font-size: 18px;
    }
  }
}
@media (min-width:767px) and (min-height: 620px) {
  #hint {
    margin: 5px 0 20px 0;
  }
}

@media (min-width:767px) and (min-height: 820px) {
  #hint {
    margin: 10px 0 25px 0;
  }
}
</style>
